import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, PortalWrapper } from 'mw-style-react';
import { useIntl } from 'hooks';
import mes from './intl';
import scss from './QuotePopup.scss';

const QUOTE_BUTTON_WIDTH = 136;

/**
 * A reusable component for displaying a quote popup when text is selected
 *
 * @param {object} props - Component props
 * @param {object} props.popupStyle - Style object for positioning the popup
 * @param {function} props.onQuoteClick - Callback function when quote button is clicked
 * @param {object} props.popupRef - Ref object for the popup
 * @param {object} props.containerRef - Ref object for the container element
 * @return {React.ReactElement|null} - Quote popup component or null if not visible
 */
function QuotePopup({
  popupStyle,
  onQuoteClick,
  popupRef,
  containerRef,
  visible,
}) {
  const t = useIntl();

  if (!visible || !containerRef?.current) return null;

  return (
    <PortalWrapper
      root={document.getElementById('mainRoot')}
      node={containerRef.current}
      width={QUOTE_BUTTON_WIDTH}
      offsetX={popupStyle.left - QUOTE_BUTTON_WIDTH / 2}
      offsetY={popupStyle.top}
      position="absolute"
    >
      <Card
        forwardRef={popupRef}
        className={scss.quotePopup}
        withBorder={false}
      >
        <Button
          size="small"
          fontWeight="normal"
          icon="quote"
          label={t(mes.quote)}
          onClick={onQuoteClick}
          fullWidth
        />
      </Card>
    </PortalWrapper>
  );
}

QuotePopup.propTypes = {
  popupStyle: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
  }).isRequired,
  onQuoteClick: PropTypes.func.isRequired,
  popupRef: PropTypes.object.isRequired,
  containerRef: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default QuotePopup;
